import type { LayoutLoad } from './$types';
import type { Breadcrumb } from '#lib/components/page/Breadcrumbs.svelte';
import type { TimeRangeSettings } from '#lib/components/page/TimeRangeEnum.svelte';

export const load = (async ({ data }) => {
  return {
    ...data,
    timeRangeSettings: <TimeRangeSettings>false,
    breadcrumbs: <Breadcrumb[]>[],
  };
}) satisfies LayoutLoad;
